import { render } from "./expense-article-view.vue?vue&type=template&id=0ca74998"
import script from "./expense-article-view.vue?vue&type=script&lang=js"
export * from "./expense-article-view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/mped/expense-article-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ca74998"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ca74998', __exports__)) {
    api.reload('0ca74998', __exports__)
  }
  
  module.hot.accept("./expense-article-view.vue?vue&type=template&id=0ca74998", () => {
    api.rerender('0ca74998', render)
  })

}


export default __exports__